import VisitasDomiciliares from '../pages/VisitasDomiciliares/VisitasDomiciliares'
import FamiliasVisitadas from '../pages/VisitasDomiciliares/FamiliasVisitadas/Index'
import CidadaosVisitados from '../pages/VisitasDomiciliares/CidadaosVisitados/Index'

export default [
  {
    path: '/visitas-domiciliares',
    component: VisitasDomiciliares,
  },
  {
    path: '/familias-visitadas',
    component: () =>
      import('@/pages/VisitasDomiciliares/FamiliasVisitadas/Template.vue'),
    children: [
      {
        path: '/familias-visitadas',
        component: FamiliasVisitadas,
      },
    ],
  },
  {
    path: '/cidadaos-visitados',
    component: () =>
      import('@/pages/VisitasDomiciliares/CidadaosVisitados/Template.vue'),
    children: [
      {
        path: '/cidadaos-visitados',
        component: CidadaosVisitados,
      },
    ],
  },
  {
    path: '/visitas-no-mes',
    component: () =>
      import('@/pages/VisitasDomiciliares/VisitasNoMes/Index.vue'),
  },
  {
    path: '/desempenho-por-microarea',
    component: () =>
      import('@/pages/VisitasDomiciliares/DesempenhoPorMicroArea/Template.vue'),
    children: [
      {
        path: '/desempenho-por-microarea',
        component: () =>
          import(
            '@/pages/VisitasDomiciliares/DesempenhoPorMicroArea/Index.vue'
          ),
      },
    ],
  },
]
